import styled from "styled-components";

export const InstantReqPageFailedStyled = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;

  & > .inner {
    width: 270px;
    margin: auto;
    .inner__white {
      padding: 12px;
      border-radius: 14px;
      width: 100%;
      background-color: #ffffff;
    }
  }

  .cancel-btn {
    border-radius: 10px;
    font-size: 0.85em;
    background-color: #ed5565;
  }
  .dark-btn {
    padding: 9px;
    border-radius: 14px;
    box-shadow: 0 2px 6px 0 rgba(42, 46, 67, 0.05);
    border: solid 1px rgba(42, 46, 67, 0.1);
    font-size: 0.9em;
    width: 100%;
  }
`;
